import SSOMyPage from './SSOMyPage';

export default SSOMyPage;
